import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Firebase configuration (Realtime Database for ads and Grow packages)
const firebaseConfig = {
  apiKey: 'AIzaSyD5HV_IVf33QUzuRfBQy_HIhcluO03SltQ',
  authDomain: 'iradio-5150a.firebaseapp.com',
  databaseURL: 'https://iradio-5150a.firebaseio.com',
  projectId: 'iradio-5150a',
  storageBucket: 'iradio-5150a.appspot.com',
  messagingSenderId: '304887383493',
  appId: '1:304887383493:web:e6281f2a168b8e577637ac',
  measurementId: 'G-E0WVR49641'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Realtime Database (ads, packages, android_tv_devices, growDevicePurchases)
export const database = getDatabase(app);

// App instance (Analytics, etc.)
export { app };

// Cloud Functions HTTP endpoints used by the admin UI
const FUNCTIONS_REGION = 'us-central1';
export const simulateDevicePurchaseUrl = `https://${FUNCTIONS_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/simulateDevicePurchase`;

